module.exports = __webpack_public_path__ + "static/img/cjzh-companyProfile.d4a369ad.jpg";